<template>
    <div class="detail">
        <div class="videoPicture" v-show="!isLoadSuccess"></div>
        <video
            width="100%"
            height="1080px"
            autoplay="autoplay"
            loop="loop"
            muted="muted"
            class="vedio1"
            src="~@/assets/Home/关于培训班背景视频.mp4"
            v-show="isLoadSuccess"
        ></video>
        <div class="shadow" id="barId"></div>
        <div class="shadowContent">
          <div class="shadowText2">吉林一号遥感开发者培训班线下培训</div>
          <div class="shadowButton" v-if="!hasSignedIn" @click="judgeSignIn()"></div>
          <div class="shadowButtonSigned" v-else @click="judgeSignIn()"></div>
          <div class="topText4" v-if="!hasSignedIn">（沈阳/长春/呼和浩特 报名开启中）</div>
          <div class="shadowText3">一、培训计划</div>
          <div class="content5Wrapper">
          <TrainSchedule
            :trainDetail="trainDetail"
            :trainCampList="trainCampList"
            @show-detail="trainDetail=true"
            @hide-detail="trainDetail=false"
            @sign-in="judgeSignIn()"
            @detail-sign-in="detailSignIn"
            @go-result="goResult()"
          />
          </div>
          <!-- <div class="content5Block" v-if="trainDetail">
            <div class="content5Text3" @click="trainDetailItem={};trainDetail=false">&lt; 返回</div>
            <div class="content5Text4">{{ trainDetailItem.name }} · {{ trainDetailItem.region }}行</div>
            <div class="content5Line1"></div>
            <div class="content5Text5">培训时间</div>
            <div class="content5Text6">
              <span v-if="trainDetailItem.startTime==null">{{ trainDetailItem.date }}</span>
              <span v-else>{{ trainDetailItem.startTime }}-{{ trainDetailItem.endTime }}</span>
            </div>
            <div class="content5Text5" style="top: 263px;">培训地点</div>
            <div class="content5Text6" style="top: 263px;">{{ trainDetailItem.specificRegion }}</div>
            <div class="content5Text5" style="top: 319px;">培训对象</div>
            <div class="content5Text6" style="top: 319px;">从事遥感测绘、地理信息及相关专业的学生、研究人员、行业从业者等</div>
            <div class="content5Text5" style="top: 375px;">课程安排</div>
            <div class="content5Text6" style="top: 375px;line-height: 30px;">涵盖吉林一号星座介绍与产品分级、吉林一号卫星数据处理技术与方法、吉林一号网工具实践等基础类课程，<br> 农业、林业、环保、水利、自然资源、能源、金融等应用类课程以及遥感智能解译等算法类课程。</div>
            <div class="content5Button" @click="judgeSignIn()">立即报名</div>
          </div> -->
          <div class="shadowText3" style="margin-top: 40px;">二、培训目标<br>
            <span style="font-weight: 300;font-family:PingFang SC;">&nbsp;&nbsp;&nbsp;&nbsp; 培训聚焦遥感应用开发能力建设，以吉林一号大模型与能力开放平台为核心技术底座，通过实战教学帮助学员掌握数据处理、智能解译及行业应用开发全流程技能，助力开发者快速构建基于吉林一号数据的创新解决方案，推动卫星遥感数据在产业落地中的深度应用。</span>
          </div>
          <div class="shadowText3" style="margin-top: 35px;">三、培训对象<br>
            <span style="font-weight: 300;font-family:PingFang SC;">&nbsp;&nbsp;&nbsp;&nbsp; 地理信息行业从业者、相关行业产品技术人员、高校教师与研究生。<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 沈阳 9月8日-9月9日  80-100人 <br>
              &nbsp;&nbsp;&nbsp;&nbsp; 长春 10月13日-10月16日 120-150人 <br>
              &nbsp;&nbsp;&nbsp;&nbsp; 呼和浩特 10月28日-10月29日 80-100人 <br>
            </span>
          </div>
          <div class="shadowText3" style="margin-top: 35px;">四、培训特色<br>
            <span style="font-weight: 300;font-family:PingFang SC;">&nbsp;&nbsp;&nbsp;&nbsp; 免费限量报名，小班制授课，专业指导，即学即做，强调互动与实战，地方行2天，集训营4天。</span>
          </div>  
          <div class="shadowText3" style="margin-top: 35px;">五、培训内容
            <img src="../assets/Home/首页培训内容.png" alt="" class="shadowImg">
          </div>    
          <div class="shadowText3" style="margin-top: 35px;">六、考核、认证及结业条件<br>
            <span style="font-weight: 300;font-family:PingFang SC;">&nbsp;&nbsp;&nbsp;&nbsp; 1. 成绩认定：签到情况+作业成绩+考核成绩，综合成绩满足标准者颁发培训证书;<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 2. 学员如有特殊情况，需请假报备，并填写请假条。累计请假时长超过3个学时（半天）的学员不予发放培训证书；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 3. 线下培训结业条件：完成线下全部学时的学习并通过线下实践课程和作业验收，颁发实体结业证书。<br>
            </span>
          </div> 
          <div class="shadowText3" style="margin-top: 35px;">七、奖励政策 (同时适用于参与线上或线下的所有学员)<br>
            <span style="font-weight: 300;font-family:PingFang SC;">&nbsp;&nbsp;&nbsp;&nbsp; 1. 优秀学生学员，符合公司硬性招聘条件情况下优先录取or实习机会；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 2. 实践课免费提供高分辨样例数据，优秀学员可获得吉林一号切片影像套件产品使用权；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 3. 结课学员所在组织有机会成为吉林一号生态合作伙伴；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 4. 通过考核的结课学员可获得实体结业证书。<br>
              <span style="color: #FFD07D;">&nbsp;&nbsp;&nbsp;&nbsp; 注：该激励政策最终解释权归长光卫星技术股份有限公司，政策可能根据实际运行情况调整<br></span>
            </span>
          </div> 
          <div class="shadowText3" style="margin-top: 35px;">八、其他须知<br>
            <span style="font-weight: 300;font-family:PingFang SC;">&nbsp;&nbsp;&nbsp;&nbsp; 1. 吉林一号线下培训为公益性质，全程不收取任何费用，培训过程中有假借名目收费行为请立即举报!<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 2. 请您保持关注培训动态，如有变动工作人员会提前告知，请保持电话畅通；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 3. 请在培训过程中自觉遵守培训场地相关规程，出现任何人身财产安全问题、损坏场地财物等问题请自行承担，培训主办方不承担任何责任；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 4. 线下培训过程不得进行任何违法、危害公共安全或不道德行为，严禁赌博、博彩、传销等，如有违反者，自动取消培训资格，移送公安机关处置；<br>
              &nbsp;&nbsp;&nbsp;&nbsp; 5. 线下培训不统一安排食宿、交通，相关费用需学员自理。<br>
            </span>
          </div> 
        </div>
        <div class="shadowText2" style="margin-top: 120px;">往期精彩时刻</div>
        <div class="swiper-containerQb">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="swiperImg1"></div>
            </div>
            <div class="swiper-slide">
              <div class="swiperImg2"></div>
            </div>
            <div class="swiper-slide">
              <div class="swiperImg3"></div>
            </div>
            <div class="swiper-slide">
              <div class="swiperImg4"></div>
            </div>
            <div class="swiper-slide">
              <div class="swiperImg5"></div>
            </div>
            <div class="swiper-slide">
              <div class="swiperImg6"></div>
            </div>
            <div class="swiper-slide">
                <div class="swiperImg7"></div>
            </div>
            <div class="swiper-slide">
                <div class="swiperImg8"></div>
            </div>
            <div class="swiper-slide">
                <div class="swiperImg9"></div>
            </div>
            <div class="swiper-slide">
                <div class="swiperImg10"></div>
            </div>
            <div class="swiper-slide">
                <div class="swiperImg11"></div>
            </div>
          </div>
        </div>
        <div class="shadowText2" style="margin-top: 120px;">线下培训直播</div>
        <div class="shadowButton1" @click="$router.push('/directSeeding')"></div>
        <div class="shadowText4">无法参加线下培训？ <span style="color: #C49760;cursor: pointer;" @click="$router.push(`/globalCourse`);">去线上课堂学习 ></span></div>
<!--        <div class="shadowCtn" v-if="shadow == 1">-->
<!--          <div class="shadowWhite">-->
<!--            <div class="text4">很抱歉！</div>-->
<!--            <div class="text5">-->
<!--              吉林一号遥感开发者培训班 · 长春站{{trainStatus}}，如有其他问题请联系我们的教育专员。-->
<!--              <br />0431-86008580 (工作日工作时)-->
<!--            </div>-->
<!--            <div class="shadowCtnButton" @click="shadow=0">关闭</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="shadowCtn" v-if="shadow == 2">-->
<!--          <div class="shadowWhite">-->
<!--            <div class="text4" style="top: 60px;">提示</div>-->
<!--            <div class="text5" style="top: 120px;">-->
<!--              您已成功报名吉林一号遥感开发者培训班 · 长春站，请勿重复报名！-->
<!--            </div>-->
<!--            <div class="shadowCtnButton" @click="shadow=0">关闭</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="shadowCtn" v-if="shadow == 3">-->
<!--        <div class="shadowWhite">-->
<!--          <div class="text4">很抱歉！</div>-->
<!--          <div class="text5" style="text-align: center;">-->
<!--            您未通过报名审核。如有问题请联系我们的教育专员。-->
<!--            <br />0431-86008580 (工作日工作时)-->
<!--          </div>-->
<!--          <div class="shadowCtnButton" @click="shadow=0">关闭</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </template>
  
  <script>
import {rootUrl} from '@/globalConfig'
  import TrainSchedule from '@/components/TrainSchedule'
  import Swiper from "swiper";
  import "swiper/css/swiper.min.css";
//   import $ from "jquery";
  export default {
    name: "courseDetail",
    components: { TrainSchedule },
    data() {
      return {
        isLoadSuccess:false,
        readyState:0,
        timer:'',
        status:0,
        trainCampList:[],
        trainDetail:false,
        trainDetailItem:{},
        //判断报名是否已截止
        signInPermit:0,
        shadow:0,
        trainStatus:'',
        //判断用户线下报名状态0：未报名、1：审核中、2：通过、3：驳回
        offlineStatus:0,
        //是否已报名（signInStatus!=='未报名'）
        hasSignedIn:false,
      };
    },
    methods: {
      getKey() {
        return localStorage.getItem("token");
      },
      //视频加载完成
      videoLoadSuccess(){
        let readyState = document.querySelector('.vedio1').readyState;
        this.readyState = readyState;
        if(readyState==4){
          this.isLoadSuccess=true;
          clearInterval(this.timer);
        } 
      },
      refreshLocation() {
        // location.reload();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      },
       //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
          //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
          //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(type=='可游客'){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }else if(type=='仅登录'){
            //已登录
            if(loginUserId){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未登录
            else {
              if(fromUrl){
                window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+'/Login',"_self")
              }
            }
          }else if(type=='仅实名'){
            //已登录
            if(loginUserId){
              //已实名
              if(authentication=='0'){
                if(fromUrl){
                  window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(rootUrl+path,"_self")
                }
              }
              //未实名
              else {
                window.open(rootUrl+'/Authentication',"_self")
              }

            }
            //未登录
            else {

              if(fromUrl){
                window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                // this.$router.push('/Login')
              }
              else {
                window.open(rootUrl+'/Login',"_self")
              }
            }
          }
        },
       //实名权限检查与处理（培训班版）
        checkAndHandleAuthentication(){
            console.log("进入实名检查")
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(!loginUserId){
              this.jumpWithPermission('仅登录','/Login','/learn/')
            }
            else if(authentication!='0'){
              this.jumpWithPermission('仅实名','/Authentication','/learn/offlineSignIn')
          }
          return true;
        },
      getCampList(){
        this.axios.get("/learn_back/course/register/getCampList", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          this.trainCampList=res.data.data.trainCampList
          console.log('[getCampList] trainCampList=', JSON.stringify(this.trainCampList))
          this.hasSignedIn = this.trainCampList.some(item => item.signInStatus !== '未报名')
          console.log('[getCampList] hasSignedIn=', this.hasSignedIn)
          this.trainStatus=this.trainCampList[0].trainStatus
          if(this.trainCampList[0].trainStatus=='名额已满'||this.trainCampList[0].trainStatus=='报名已截止'){
            this.signInPermit=1
          }
        })
      },
      getOfflineStatus(){
        this.axios.get("/learn_back/course/register/getOfflineStatus?qs=13", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          this.offlineStatus=res.data.data
        })
      },
      judgeSignIn(){
        if(this.checkAndHandleAuthentication()){
          // 立即报名直接跳报名页;已报名则查看报名结果
          this.$router.push(this.hasSignedIn ? '/offlineResult' : '/offlineSignIn')
        }
      },
      goTrainDetail(item){
        this.trainDetailItem = item
        this.trainDetail=true
      },
      // 查看详细课程安排内「立即报名」:跳转 offlineSignIn 并携带当前期数 qs
      detailSignIn(qs){
        if(this.checkAndHandleAuthentication()){
          this.$router.push({ path: '/offlineSignIn', query: { qs: qs } })
        }
      },
      goResult(){
        this.$router.push('/offlineResult')
      },
      mySwiper() {
      var mySwiper = new Swiper(".swiper-containerQb", {
        effect: "slide", //切换效果
        slidesPerView: 3, // 同时显示几个sliders
        //* 自动播放
        speed: 10000,
        freeMode: true, //根据惯性滑动可能不止一格且不会贴合
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        loop: true, //循环
        autoHeight: true,
      });
    },
    },
  
    mounted() {
    document.getElementById('barId').scrollIntoView({ behavior: "instant"});

      this.videoLoadSuccess();
      this.mySwiper()
      this.$nextTick(() => {
        this.timer = setInterval(this.videoLoadSuccess, 10);
        let className = decodeURI(window.location.search).replace("?class=", "");
        if (className) document.querySelector("." + className).scrollIntoView(true);
      });
      this.getCampList()
      this.getOfflineStatus()

    },
  };
  </script>
  
  <style scoped>
  .detail{
    position: relative;
    width: 100%;
    height: auto;
    background:#000000;
    padding-bottom: 150px;
  }
  .videoPicture{
    position: fixed;
    width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
    background-image: url(~@/assets/Home/视频图片.jpg);
    background-size: 100% 100%;
  }
  .vedio1 {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 牛逼哦 */
  object-fit: cover;
  /* margin-top: -20rem; */
}
.shadow{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.70);
    /* z-index: 2; */
}
.shadowContent{
    position: relative;
    margin-top: 0;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: auto;
    overflow: hidden;
}
.shadowText1{
    position: absolute;
    top: 127px;
    left: 0;
    width: 100px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
}
.shadowLine{
    position: absolute;
    top: 174px;
    left: 0;
    width: 1280px;
height: 1px;
background-color:  rgba(255,255,255,0.2);
}
.shadowText2{
    position: relative;
    margin-top: 201px;
    margin-left: calc(50% - 400px);
    width:800px;
    height: 42px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 42px;
    text-align: center;
}
.shadowButton{
    position: relative;
    margin-top: 74px;
    margin-left: calc(50% - 84px);
    width: 168px;
  height: 56px;
  border-radius: 22px;
  background: url("~@/assets/Home/立即报名_default.png") no-repeat;
    background-size: 100% 100%;
  cursor: pointer;
  transition: 0.5s;
}
.shadowButton:hover{
background: url("~@/assets/Home/立即报名_hover.png") no-repeat;
background-size: 100% 100%;
}
.shadowButtonSigned{
    position: relative;
    margin-top: 74px;
    margin-left: calc(50% - 84px);
    width: 168px;
  height: 56px;
  border-radius: 22px;
  background: url("~@/assets/Home/已报名_default.png") no-repeat;
    background-size: 100% 100%;
  cursor: pointer;
  transition: 0.5s;
}
.shadowButtonSigned:hover{
background: url("~@/assets/Home/已报名_hover.png") no-repeat;
background-size: 100% 100%;
}
.shadowButton1{
    position: relative;
    margin-top: 74px;
    margin-left: calc(50% - 91px);
  width: 182px;
height: 56px;
border-radius: 22px;
background: url("~@/assets/Home/进入直播间.png") no-repeat;
  background-size: 100% 100%;
cursor: pointer;
transition: 0.5s;
}
.shadowButton1:hover{
background: url("~@/assets/Home/进入直播间1.png") no-repeat;
background-size: 100% 100%;
}
.shadowText3{
    position: relative;
   margin-top: 74px;
    margin-left: 0;
    width: 1280px;
    height:auto;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 32px;
    text-align: left;
}
.shadowText4{
  position: relative;

}
.shadowImg{
    position: relative;
    display: block;
    margin-top: 20px;
    width: 1190px;
    height: 150px;
    margin-left: 45px;
}

  </style>
  <style scoped>
.content5Text3{
  position: absolute;
  width: 50px;
  height: 16px;
  top: 50px;
  left: 50px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: right;
  cursor: pointer;
}
.content5Text4{
  position: absolute;
  top: 79px;
  width: 1280px;
height: 28px;
font-family: Tensentype-ZhiHeiJ, Tensentype-ZhiHeiJ;
font-weight: normal;
font-size: 26px;
color: #FFFFFF;
line-height: 28px;
text-align: center;
}
.content5Line1{
  position: absolute;
  top: 157px;
  left: 215px;
  width: 870px;
height: 1px;
border-top: 1px solid rgba(255,255,255,0.2);
}
.content5Text5{
  position: absolute;
  top: 207px;
  left: 215px;
  width: auto;
  height: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 16px;
  color: rgba(255,255,255,0.6);
  line-height: 16px;
}
.content5Text6{
  position: absolute;
  top: 207px;
  left: 310px;
  width:774px;
  height: auto;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 16px;
color: #FFFFFF;
line-height: 16px;
}
.content5Wrapper{
  margin-top: 20px;
}
.swiper-containerQb{
  position: relative;
  width: 100%;
  height: 450px;
  margin-top: 75px;
  margin-left: 0;
  /* margin-left: calc(50% - 640px); */
}
.swiperImg1{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/1.png');
  background-size: 100% 100%;
}
.swiperImg2{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/2.png');
  background-size: 100% 100%;
}
.swiperImg3{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/3.png');
  background-size: 100% 100%;
}
.swiperImg4{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/4.png');
  background-size: 100% 100%;
}
.swiperImg5{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/5.png');
  background-size: 100% 100%;
}
.swiperImg6{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/6.png');
  background-size: 100% 100%;
}
.swiperImg7{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/7.png');
  background-size: 100% 100%;
}
.swiperImg8{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/8.png');
  background-size: 100% 100%;
}
.swiperImg9{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/9.png');
  background-size: 100% 100%;
}
.swiperImg10{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/10.png');
  background-size: 100% 100%;
}
.swiperImg11{
  float: left;
  width: 600px;
  height: 450px;
  background-image: url('../assets/Home/滚动照片/11.png');
  background-size: 100% 100%;
}
.shadowText4{
  position: relative;
  margin-top: 100px;
  margin-left: calc(50% - 640px);
  width: 1280px;
height: 20px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 20px;
color: #FFFFFF;
line-height: 20px;
text-align: center;
}
.topText4{
  position: absolute;
  top: 380px;
  left: 50%;
  transform: translate(-50%,0);
  width:auto;
  height: 60px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: rgba(255,255,255,1);
  line-height: 30px;
  text-align: center;
}
.shadowWhite {
  position: absolute;
  top: calc(50% - 150px);
  left: calc(50% - 300px);
  width: 600px;
  height: 300px;
  background: #ffffff;
  border-radius: 16px;
}
.text4 {
  position: absolute;
  top: 30px;
  left: calc(50% - 300px);
  width: 600px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  text-align: center;
}
.text5 {
  position: absolute;
  top: 90px;
  left: calc(50% - 250px);
  width: 500px;
  height: 324px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
}
.shadowCtnButton {
  position: absolute;
  top: 230px;
  left: calc(50% - 48px);
  width: 96px;
  height: 44px;
  background: #c49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.shadowCtn{
  position: fixed;
  top: 0;
  width: 100%;
  height:100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}
</style>
<style scoped>
.swiper-wrapper {
      transition-timing-function: linear !important; /* 没错就是这个属性 */
    }

</style>
  